/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import * as DateUtils   from 'lib/DateUtils';
import PropTypes        from 'prop-types';
import React            from 'react';
import moment from 'moment-timezone';
import styles           from 'components/LogView/LogViewEntry.scss';

const TIMESTAMP_REGEX = [
  '([a-z])', // Any Single Word Character (Not Whitespace) 1
  '((?:2|1)\\d{3}(?:-|\\/)(?:(?:0[1-9])|(?:1[0-2]))(?:-|\\/)(?:(?:0[1-9])|(?:[1-2][0-9])|(?:3[0-1]))(?:T|\\s)(?:(?:[0-1][0-9])|(?:2[0-3])):(?:[0-5][0-9]):(?:[0-5][0-9]))', // Time Stamp 1
  '(\\.)',  // Any Single Character 1
  '(\\d)',  // Any Single Digit 1
  '(\\d)',  // Any Single Digit 2
  '(\\d)',  // Any Single Digit 3
  '([a-z])',  // Any Single Word Character (Not Whitespace) 2
  '(\\])'  // Any Single Character 2
].join('');

// let isError = (str) => str[0] === 'E';

let getLogEntryInfo = (str, level) => {
  let re = getTimestampRegex();
  let timeStampStr = str.match(re) ? str.match(re)[0] : '';
  return {
    time: timeStampStr,
    content: str.replace(timeStampStr,''),
    error: level == 'error'
  };
}

//example timestamp: 'I2015-09-30T00:36:45.522Z]'
let getTimestampRegex = () => new RegExp(TIMESTAMP_REGEX,['i']);

let LogViewEntry = ({ enableDate=true, text = '', level, timestamp, meta = {}, customClass }) => {
  // start fucking hack
  let textLog

  if (text) {
    if(
       text.indexOf("MongoError") !== -1 ||
       text.indexOf("DeprecationWarning") !== -1 ||
       text.indexOf("uncaughtException") !== -1 ||
       meta && meta.name == "MongoError"
    ) {
      return null
    } else {
      if(text.includes('uncaughtException "Error: socket hang up') || text.includes('TLSSocket.onHangUp')) {
        return null
      }

      textLog = text
    }
  } else {
    if (meta && meta.name != "MongoError"){
      textLog = `${meta.name}: ${meta.message}`
    } else {
      return null
    }
  }

  // end fucking hack

  const classes = [styles.entry, styles[level], styles[customClass]];

  return (
    <div className={classes.join(' ')}>
      {
        enableDate &&
          <span className={styles.time}>{moment(timestamp).format("MMM DD, YYYY, HH:mm:ss Z")}{level ? `- ${level.toUpperCase()}` : ''}</span>
      }
      <span className={styles.content}>{textLog}</span>
      {
        enableDate &&
          <span className={styles.stack}>{meta ? meta.stack : ''}</span>
      }
    </div>
  );
}

export default LogViewEntry;
